import React, { useState } from "react";
import { Link } from "react-router-dom";
import { CategoryBadge } from "./category-badge";
import { Clock, Eye } from "lucide-react";
import "../../../css/blogs.css"; // Import the CSS file

export const BlogCard = ({ post, featured = false }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const formattedDate = new Date(post.createdAt).toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });

  if (featured) {
    return (
      <div className="blog-card-featured">
        <Link to={`/blog/${post.slug}`} className="blog-card-featured-link">
          <div className="blog-card-image-container-featured">
            {!imageLoaded && (
              <div className="blog-card-image-loading-shimmer" />
            )}
            <img
              src={post.featuredImage}
              alt={post.title}
              className="blog-card-image"
              onLoad={() => setImageLoaded(true)}
              loading="lazy"
            />
          </div>
          <div className="blog-card-content-featured">
            <CategoryBadge category={post.category} />
            <h2 className="blog-card-title-featured">{post.title}</h2>
            {post.excerpt && (
              <p className="blog-card-excerpt">{post.excerpt}</p>
            )}
            <div className="blog-card-meta-featured">
              <div className="blog-card-meta-item">
                <Clock size={14} className="blog-card-meta-icon" />
                <span>{formattedDate}</span>
              </div>
              <div className="blog-card-meta-item">
                <Eye size={14} className="blog-card-meta-icon" />
                <span>{post.readTime}</span>
              </div>
            </div>
          </div>
        </Link>
      </div>
    );
  }

  return (
    <article className="blog-card">
      <Link to={`/blog/${post.slug}`}>
        <div className="blog-card-image-container">
          {!imageLoaded && <div className="blog-card-image-loading-shimmer" />}
          <img
            src={post.featuredImage}
            alt={post.title}
            className="blog-card-image"
            onLoad={() => setImageLoaded(true)}
            loading="lazy"
          />
        </div>
        <div className="blog-card-content">
          <CategoryBadge category={post.category} />
          <h3 className="blog-card-title">{post.title}</h3>
          <div className="blog-card-meta">
            <div className="blog-card-meta-item">
              <Clock size={14} className="blog-card-meta-icon" />
              <span>{formattedDate}</span>
            </div>
            <div className="blog-card-meta-item">
              <Eye size={14} className="blog-card-meta-icon" />
              <span>{post.readTime}</span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
};
